import { Enum } from '@utils/enum';

export const elements = Enum(
  // HEADINGS
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  // TEXTS
  'p',
  'span',
  'div',
);

export type ElementType = keyof typeof elements;
